"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ActionCard = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Storyblok = _interopRequireDefault(require("../../../../../../utils/Storyblok"));

var _appRedirect = _interopRequireDefault(require("../../../../../../utils/appRedirect"));

var _customProps = require("../../../../../../utils/customProps");

var _Typography = _interopRequireDefault(require("../../../../../../components/PageGrid/molecules/Typography/Typography"));

var _Icon = _interopRequireDefault(require("../../../../../../components/PageGrid/atoms/Icon/Icon"));

var _ActionCardModule = _interopRequireDefault(require("./ActionCard.module.scss"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ActionCard = function ActionCard(_ref) {
  var header = _ref.header,
      icon = _ref.icon,
      text = _ref.text,
      height = _ref.height,
      width = _ref.width,
      rootClass = _ref.rootClass,
      redirectRoute = _ref.redirectRoute;

  var classes = _Storyblok.default.anchorOrginToObj(rootClass);

  var onClick = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", (0, _appRedirect.default)(redirectRoute));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onClick() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react.default.createElement("div", {
    style: _objectSpread({
      height: height,
      width: width
    }, classes),
    className: _ActionCardModule.default.actionCard,
    onClick: onClick,
    id: "actionCard-test"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _ActionCardModule.default.actionHeader
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, icon[0]), /*#__PURE__*/_react.default.createElement(_Typography.default, header[0])), /*#__PURE__*/_react.default.createElement("div", {
    className: _ActionCardModule.default.actionBody
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, text[0])));
};

exports.ActionCard = ActionCard;
var _default = ActionCard;
exports.default = _default;
ActionCard.propTypes = {
  /**
   * storyblok multiselect of css classes
  */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * Cards passed to ActionCard to render
   * Component: MuiTypography
   */
  header: function header(props, propName, componentName) {
    var components = ['MuiTypography'];
    return (0, _customProps.validComponents)(props, propName, componentName, components, 1);
  },

  /**
   * Cards passed to ActionCard to render
   * Component: MuiIcon
   */
  icon: function icon(props, propName, componentName) {
    var components = ['MuiIcon'];
    return (0, _customProps.validComponents)(props, propName, componentName, components, 1);
  },

  /** redirect route */
  redirectRoute: _propTypes.default.string.isRequired,

  /**
   * Cards passed to ActionCard to render
   * Component: MuiTypography
   */
  text: function text(props, propName, componentName) {
    var components = ['MuiTypography'];
    return (0, _customProps.validComponents)(props, propName, componentName, components, 1);
  },

  /**
   * Passed down from ActionCardContainer
   * Height of the each Action Card.
   */
  height: function height(props, propName, componentName) {
    return (0, _customProps.dimensionProp)(props, propName, componentName);
  },

  /**
   * Passed down from ActionCardContainer
   * Width of the each Action Card.
   */
  width: function width(props, propName, componentName) {
    return (0, _customProps.dimensionProp)(props, propName, componentName);
  }
};
ActionCard.defaultProps = {
  height: '100px',
  width: '200px',
  rootClass: [],
  text: [],
  icon: [],
  header: []
};